export default __webpack_public_path__ + "static/0068-95fca0aa9a139dae5fd9892626209cbb.png";